import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../../data/Axios/DynamicForm";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice, setupManagementUrl } from "../../../../../config";
const base_url = customerservice.uri;
const setup_url = setupManagementUrl.uri;

const CustomerSecurityForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const customerId = parseInt(localStorage.getItem("CustomerId"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [location, setLocation] = useState([]);
  const [classData, setClassData] = useState([]);
  const [collateralTypes, setCollateralTypes] = useState([]);
  const [subclass, setSubclass] = useState([]);
  const [condition, setCondition] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editedDaata, setEditedData] = useState(null);
  const [customerRelationshipData, setCustomerRelationshipData] = useState([]);
  const [formData, setFormData] = useState({
    idFrontPhoto: null,
    idBackPhoto: null,
    photo: null,
  });

  useEffect(() => {
    async function fetchAllData() {
      try {
        const locationresponse = await fetchJsonDynamic(
          "collateralLocations",
          null,
          null,
          setup_url
        );
        const CollateralClassresponse = await fetchJsonDynamic(
          "collateralClasses",
          null,
          null,
          setup_url
        );
        const CollateralConditionresponse = await fetchJsonDynamic(
          "collateralConditions",
          null,
          null,
          setup_url
        );
        const CollateralTyperesponse = await fetchJsonDynamic(
          "collateralTypes",
          null,
          null,
          setup_url
        );
        const collateralsubclassresponse = await fetchJsonDynamic(
          "collateralSubclasses",
          null,
          null,
          setup_url
        );
        if (CollateralClassresponse?.results) {
          const result = JSON.parse(CollateralClassresponse?.results);
          setClassData(result || []);
        }
        if (locationresponse?.results) {
          const results = JSON.parse(locationresponse?.results);
          setLocation(results || []);
        }
        if (CollateralConditionresponse?.results) {
          const results = JSON.parse(CollateralConditionresponse?.results);
          setCondition(results || []);
        }
        if (CollateralTyperesponse?.results) {
          const results = JSON.parse(CollateralTyperesponse?.results);
          setCollateralTypes(results || []);
        }
        if (collateralsubclassresponse?.results) {
          const results = JSON.parse(collateralsubclassresponse?.results);
          setSubclass(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  const locationresponse = location.map((status) => ({
    value: status.Id,
    label: status.Location,
  }));
  const CollateralClassresponse = classData.map((relation) => ({
    value: relation.Id,
    label: relation.Name,
  }));
  const CollateralConditionresponse = condition.map((relation) => ({
    value: relation.Id,
    label: relation.Condition,
  }));

  const formatDate = (date) => {
    if (!date) return null;
    return date.split("T")[0];
  };

  //Security

  const initialValues = {
    id: props.data ? props.data.Id : "",
    relationshipToLoanee: props.data ? props.data.RelationshipToLoanee : "",
    collateralclassid: props.data ? props.data.Collateralclassid : "",
    collateralsubclassid: props.data ? props.data.Collateralsubclassid : "",
    collateraltypeid: props.data ? props.data.Collateraltypeid : "",
    conditionid: props.data ? props.data.Conditionid : "",
    description: props.data ? props.data.Description : "",
    locationid: props.data ? props.data.Locationid : "",
    model: props.data ? props.data.Model : "",
    // relationshipToLoanee:props.data ? props.data.Collateralclassid : "",
    securityholderid: props.data ? props.data.Holdersidentity : "",
    serialno: props.data ? props.data.Serialno : "",
    validity: props.data ? props.data.Validity : "",
    value: props.data ? props.data.Securityvalue : "",
    yearofpurchase: props.data ? formatDate(props.data.Yearofpurchase) : "",
    photo: props.data ? props.data.Photo : "",
  };

  const resizeImage = (
    file,
    maxWidth = 800,
    maxHeight = 800,
    quality = 0.7
  ) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            if (width > height) {
              height *= maxWidth / width;
              width = maxWidth;
            } else {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => resolve(blob), "image/png", quality);
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const convertFileToBase64 = (file) => {
    if (!file) return null;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = async (fieldName, file) => {
    if (file) {
      const resizedFile = await resizeImage(file);
      const base64String = await convertFileToBase64(resizedFile);
      setFormData((prev) => ({
        ...prev,
        [fieldName]: base64String,
      }));
    }
  };
  const handleEditFileChange = async (file) => {
    if (file) {
      try {
        const resizedFile = await resizeImage(file); // Resize the image (optional)
        const base64String = await convertFileToBase64(resizedFile); // Convert to Base64
        return base64String; // Update state
      } catch (error) {
        console.error("Error processing file:", error);
      }
    }
  };

  const onFieldChange = async (field, value) => {
    let updatedOptions = {};
    if (field.name === "collateralclassid") {
      //fetching subclass by classid
      const CollateralConditionresponse = await fetchJsonDynamic(
        "allCollateralSubClassesByColumnValues",
        "parameters",
        { classid: value },
        setup_url
      );

      if (CollateralConditionresponse?.results) {
        const results = JSON.parse(CollateralConditionresponse?.results);
        setSubclass(results || []);
      }
    }

    if (field.name === "collateralsubclassid") {
      //fetching collateraltypes by subclassid
      const CollateralTypesResponse = await fetchJsonDynamic(
        "allCollateralTypesByColumnValues",
        "parameters",
        { subclassid: value },
        setup_url
      );

      if (CollateralTypesResponse?.results) {
        const results = JSON.parse(CollateralTypesResponse?.results);
        setCollateralTypes(results || []);
      }
    }
  };
  // Filter minor classification options based on the selected major classification ID
  const collateralsubclassresponse = subclass
    ? subclass.map((relation) => ({
        value: relation.Id,
        label: relation.Name,
      }))
    : [];
  const collateralTypesOptions = collateralTypes
    ? collateralTypes.map((relation) => ({
        value: relation.Id,
        label: relation.Type,
      }))
    : [];

  const forms = [
    {
      name: "description",
      label: "Description*",
      type: "text",
      // options: maritalSt/atusOptions,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "securityholderid",
      label: "Collateral Holder Id *",
      type: "number",
      // options: maritalStatusOptions,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "collateralclassid",
      label: "Collateral Class *",
      type: "select",
      options: CollateralClassresponse,
      gridColumn: "span 2",
      required: true,
      parent: "main",
    },
    {
      name: "collateralsubclassid",
      label: "Collateral Sub-Class *",
      type: "select",
      options: collateralsubclassresponse,
      gridColumn: "span 2",
      parent: "main",
      required: true,
    },
    {
      name: "collateraltypeid",
      label: "Collateral Type*",
      type: "select",
      options: collateralTypesOptions,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "locationid",
      label: "Location *",
      type: "select",
      options: locationresponse,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "conditionid",
      label: "Collateral Condition *",
      type: "select",
      options: CollateralConditionresponse,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "value",
      label: "Security Value *",
      type: "number",
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "model",
      label: "Model *",
      type: "text",
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "serialno",
      label: "Serial Number *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "validity",
      label: "Collateral Validity *",
      type: "text",
      // options: customerRelationshipOptions,
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "yearofpurchase",
      label: "Year of Purchase *",
      type: "date",
      // options: customerRelationshipOptions,
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "photo",
      label: "Photo (Optional)",
      type: "file",
      accept: "image/*",
      gridColumn: "span 4",
      onChangeHandler: (e) => handleFileChange("photo", e.target.files[0]),
      render: () => (
        <div>
          {props.isEditing && props.data?.Photo && (
            <div style={{ marginBottom: "10px" }}>
              <img
                src={`data:image/png;base64,${props.data.Photo}`}
                alt="Selfie"
                style={{ maxWidth: "200px", maxHeight: "200px" }}
              />
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange("photo", e.target.files[0])}
          />
        </div>
      ),
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        collateralclassid,
        collateralsubclassid,
        collateraltypeid,
        conditionid,
        description,
        locationid,
        model,
        photo,
        // relationshipToLoanee,
        securityholderid,
        serialno,
        validity,
        value,
        yearofpurchase,
      } = values;

      const EditedPhoto=await handleEditFileChange(photo);
      const selfiePhotoBase64 =
      formData.photo ||
      (EditedPhoto !== null
      ? EditedPhoto
      : props.data.Photo);
      

      const mutationData = {
        customerid: customerId,
        description,
        securitytypeid: collateraltypeid,
        securityholderid,
        collateralclassid,
        collateralsubclassid,
        collateraltypeid,
        locationid,
        conditionid,
        model,
        serialno,
        photo: selfiePhotoBase64,
        securityvalue: parseFloat(value),
        yearofpurchase,
        validity,
        isverified: 0,
      };

      if (props.isEditing) {
        mutationData.id = props.data.Id;
      }

      const response = await executeAnyMutation(
        props.isEditing ? "updateCollateralSecurity" : "createCustomerSecurity",
        mutationData,
        "result",
        false,
        base_url
      );

      if (response.results) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Customer Collateral ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      } else if (response.error) {
        let errorMessage = "An unknown error occurred.";
        try {
          const errorObj =
            typeof response.error === "string"
              ? JSON.parse(response.error)
              : response.error;
          if (typeof errorObj === "string") {
            errorMessage = errorObj;
          } else if (errorObj?.error) {
            errorMessage = errorObj.error;
          } else if (errorObj?.Error) {
            errorMessage =
              errorObj.Error.match(/System\.Exception: (.*?)\./)?.[1] ||
              errorObj.Error;
          }
        } catch (err) {
          errorMessage = response.error;
        }
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please contact the Admin.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={forms}
      onSubmit={handleSubmit}
      title={
        props.isEditing ? "Edit Customer Security" : "Create Customer Security"
      }
      subtitle={
        props.isEditing
          ? "Edit an Existing Customer Security"
          : "Create a Customer Security"
      }
      onFieldChange={onFieldChange}
    />
  );
};

export default CustomerSecurityForm;
